var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2899)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_2899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8077 13.6241H41.8056V17.0695H29.8077V13.6241Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8077 22.2375H41.8056V25.6829H29.8077V22.2375Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8077 30.8506H41.8056V34.2959H29.8077V30.8506Z",
    fill: "#0D5C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2336 5.01111H4.09813C3.18925 5.01202 2.31787 5.3753 1.67519 6.02123C1.03252 6.66715 0.671074 7.54295 0.670166 8.45643V39.4643C0.671074 40.3778 1.03252 41.2536 1.67519 41.8995C2.31787 42.5454 3.18925 42.9087 4.09813 42.9096H45.2336C46.1424 42.9082 47.0135 42.5448 47.6561 41.899C48.2987 41.2532 48.6602 40.3776 48.6616 39.4643V8.45643C48.6607 7.54295 48.2993 6.66715 47.6566 6.02123C47.0139 5.3753 46.1425 5.01202 45.2336 5.01111ZM4.09813 8.45643H22.9519V39.4643H4.09813V8.45643ZM26.3799 39.4643V8.45643H45.2336L45.2371 39.4643H26.3799Z",
    fill: "#0D5C63"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.165771)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_2899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 37.92,
    fill: "white",
    transform: "translate(0.665771 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.56d637ba265ef1f46bcc3e7da653c98a.svg";
export { ForwardRef as ReactComponent };